export default function EmbargoedWatermark() {
  return (
    <div
      role="presentation"
      className="pointer-events-none fixed top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 rotate-[-55deg] whitespace-nowrap text-[20vw] text-[rgba(141,141,141,0.5)] md:rotate-[-40deg] lg:rotate-[-35deg] lg:text-[10vw]"
    >
      EMBARGOED
    </div>
  );
}
